import { Text, View } from '@react-pdf/renderer';

import { IInvoicePdf } from '../../types/IInvoicePdf';
import { InvoiceTemplate } from '../InvoiceTemplateForm';

import styles from './Styles';

export const Information = ({
  invoice: { raisedDate, dueDate, invoiceCode },
  template,
}: {
  invoice: IInvoicePdf;
  template?: InvoiceTemplate;
}) => (
  <>
    {(template?.informationInvoiceDate ?? true) && (
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', margin: 2 }}>
        <Text style={styles.color_text}>Invoice Date:</Text>
        <Text style={styles.text}>{raisedDate}</Text>
      </View>
    )}
    {(template?.informationInvoiceNumber ?? true) && (
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', margin: 2 }}>
        <Text style={styles.color_text}>Invoice Number:</Text>
        <Text style={styles.text}>{invoiceCode}</Text>
      </View>
    )}
    {(template?.informationInvoiceDueDate ?? true) && (
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', margin: 2 }}>
        <Text style={styles.color_text}>Invoice Due Date:</Text>
        <Text style={styles.text}>{dueDate}</Text>
      </View>
    )}
  </>
);
